/* Legend eBikes · acordeón del FAQ
   Abre el artículo al que apunta el ancla (desde el buscador, el índice
   o un enlace interno) y despliega todo al buscar con Ctrl+F. */

(function () {
  function abrir(hash) {
    if (!hash || hash.length < 2) return;
    var el;
    try {
      el = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (el && el.tagName === 'DETAILS') {
      el.open = true;
      setTimeout(function () {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 60);
    }
  }

  abrir(window.location.hash);

  window.addEventListener('hashchange', function () {
    abrir(window.location.hash);
  });

  document.querySelectorAll('.lfaq-indice a, .lfaq-cuerpo a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function () {
      setTimeout(function () {
        abrir(a.getAttribute('href'));
      }, 10);
    });
  });

  // Ctrl+F / Cmd+F despliega los cerrados para que el navegador los encuentre
  document.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
      document.querySelectorAll('.lfaq-item:not([open])').forEach(function (d) {
        d.open = true;
      });
    }
  });

  // Botón flotante: aparece al pasar el índice, vuelve a él al pulsarlo
  var btn = document.querySelector('[data-lfaq-volver]');
  var indice = document.querySelector('.lfaq-indice');

  if (btn && indice) {
    btn.hidden = false;

    btn.addEventListener('click', function () {
      indice.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if ('IntersectionObserver' in window) {
      // se muestra solo cuando el índice ha salido de pantalla
      new IntersectionObserver(function (entradas) {
        btn.classList.toggle('on', !entradas[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(indice);
    } else {
      window.addEventListener('scroll', function () {
        btn.classList.toggle('on', window.scrollY > indice.offsetTop + 120);
      }, { passive: true });
    }
  }
})();
